import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { PaintableModule } from 'paintablejs/angular';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, FormsModule, PaintableModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
